import { Component, Inject, AfterViewInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GenericDialogData } from './generic-dialog-data';

@Component({
  selector: 'generic-dialog-component',
  templateUrl: 'generic-dialog.component.html',
  styleUrls: ['./generic-dialog.component.scss'],
})
export class GenericDialogComponent implements AfterViewInit {
  constructor(@Inject(MAT_DIALOG_DATA) public data: GenericDialogData) { }

  ngAfterViewInit() {
    const dialogTitle = document.getElementById('dialogMainContentTitle');
    if (dialogTitle) {
      dialogTitle.focus();
    }
  }
}
